import React, {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle
} from "react";
import { toPairs } from "lodash";
import importAll from "import-all.macro";

import Video from "./Video";
import {
  loadPoseData,
  usePoseDetection,
  useRepsCounter,
  mediaSize
} from "./poseUtils";

const videoFiles = toPairs(importAll.sync("../videos/**/*.mov"));

const MediaPose = forwardRef((props, ref) => {
  const [play, setPlay] = useState(false);
  const [timer, setTimer] = useState(987);

  const canvasRef = useRef(null);
  const videoRef = useRef(null);
  var poseData = props.poseData;
  var src = props.src;

  useImperativeHandle(ref, () => ({
    playVideo() {
      setPlay(true);
      setTimer(60);
    }
  }));

  const pose = usePoseDetection(
    play,
    poseData.net,
    videoRef.current,
    canvasRef.current
  );
  const reps = useRepsCounter(pose, poseData.vptree);

  useEffect(() => {
    var interval = setInterval(() => {
      if (timer > 0 && timer !== 987) {
        setTimer(timer - 1);
      }
      if (timer === 0) {
        props.whenFinished(reps);
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [timer, reps]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "relative"
      }}
    >
      <div>
        <span
          style={{
            position: "absolute",
            color: "#AF1F24",
            fontWeight: "bold",
            fontSize: 68,
            width: 80,
            height: 80,
            backgroundColor: "#ffffff90",
            wordWrap: "break-word",
            whiteSpace: "pre-line",
            top: "0%"
          }}
        >
          {reps}
        </span>
        <span
          style={{
            position: "absolute",
            color: "#AF1F24",
            fontWeight: "bold",
            fontSize: 68,
            width: 160,
            height: 80,
            backgroundColor: "#ffffff90",
            wordWrap: "break-word",
            whiteSpace: "pre-line",
            top: "0%",
            left: "57%"
          }}
        >
          {timer === 987 ? "0:60" : "0:" + timer}
        </span>
        <canvas
          width={mediaSize}
          height={mediaSize}
          ref={canvasRef}
          style={{ position: "absolute" }}
        />
        <Video
          width={mediaSize}
          height={mediaSize}
          src={src}
          play={play}
          videoRef={videoRef}
        />
      </div>
      {/* <button
        style={{ height: 40, width: 100, margin: "auto" }}
        onClick={() => setPlay(false)}
      >
        START
      </button> */}
    </div>
  );
});

class Images extends React.Component {
  state = {
    loadedPoses: false,
    src: "camera"
  };

  setup = async () => {
    this.child = React.createRef();
    this.poseData = await loadPoseData();
    console.log("LOADED ALL POSES!!!");
    this.setState({ loadedPoses: true });
  };

  async componentDidMount() {
    await this.setup();
  }

  sVideo = () => {
    this.child.current.playVideo();
  };

  render() {
    const { loadedPoses, src } = this.state;
    return (
      loadedPoses && (
        <div>
          <MediaPose
            ref={this.child}
            key={src}
            src={src}
            poseData={this.poseData}
            whenFinished={this.props.whenFinished}
          />
          {/* <select
            defaultValue="camera"
            onChange={e => this.setState({ src: e.target.value })}
          >
            <option value="camera">Camera</option>
            {videoFiles.map(([filename, path]) => (
              <option key={path} value={path}>
                {filename}
              </option>
            ))}
          </select> */}
        </div>
      )
    );
  }
}

export default Images;
